import { createSelector } from 'reselect';

import { getIsFromPlayerRowFromProps } from '../../selectors/_propsGetters_';
import {
  selectEntitiesBetsEntityCurrentTotal,
  selectEntitiesBetsEntitySpecialBetValue,
} from '../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { getSrPlayerIdsFromSBV } from '../../utils/bet';

const makeBetCurrentTotalTagPropsSelector = () => {
  const selectIsVisible = createSelector(
    [getIsFromPlayerRowFromProps, selectEntitiesBetsEntitySpecialBetValue],
    (isFromPlayerRow, betSBV) => {
      const srPlayerIds = getSrPlayerIdsFromSBV(betSBV);

      return (isFromPlayerRow && srPlayerIds !== null) || (!isFromPlayerRow && srPlayerIds === null);
    },
  );

  const selectCurrentTotal = createSelector(
    [selectEntitiesBetsEntityCurrentTotal, selectIsVisible],
    (currentTotal, isVisible) => (isVisible ? currentTotal : undefined),
  );

  return createSelector([selectCurrentTotal], (currentTotal) => ({
    currentTotal,
  }));
};

export default makeBetCurrentTotalTagPropsSelector;
